
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contact from './components/pages/Contact';
import Aboutpage from './components/pages/Aboutpage';

import ServiceNew from './components/pages/ServiceNew';
import Gallery from './components/pages/Gallery';

function App() {
  return (
        <BrowserRouter>
        {/* <Header/> */}

        <Routes>
          <Route path="/" element={<Home />} />
            <Route path="/contactus" element={<Contact />} />
             <Route path="/aboutus" element={<Aboutpage />} />
                <Route path="/services" element={<ServiceNew />} />
                 <Route path="/Gallery" element={<Gallery />} />
                 </Routes>



        <Footer />

      </BrowserRouter>
  );
}

export default App;
